import {CarouselEmbedProcessor} from 'app/general/structures/UserContentContainer/nodeProcessors/CarouselEmbed/CarouselEmbedProcessor';

import {EmbedlyVideoEmbedProcessor} from './EmbedlyVideoEmbed/EmbedlyVideoEmbedProcessor';
import {MakeImagesZoomableProcessor} from './MakeImagesZoomable/MakeImagesZoomableProcessor';
import {SkipProcessorsIfCredentialsProcessor} from './SkipProcessorsIfCredentials';
import {SweetVideoEmbedProcessor} from './SweetVideoEmbed/SweetVideoEmbedProcessor';
import {WrapVideoInDiffMarksProcessor} from './WrapVideoInDiffMarks';

import type {ProcessorType} from './node-processors-types';

export type {
  ProcessorType,
  ProcessorExtraOptions,
  NodeType,
} from './node-processors-types';

export const nodeProcessors: Array<ProcessorType> = [
  SkipProcessorsIfCredentialsProcessor,
  WrapVideoInDiffMarksProcessor,
  SweetVideoEmbedProcessor,
  EmbedlyVideoEmbedProcessor,
  CarouselEmbedProcessor,
  MakeImagesZoomableProcessor,
];
